import React from 'react';
import { MapPin } from 'lucide-react';
import Shivling from '../../assets/Shivling.jpeg';

const Hero = () => {
  return (
    <section className="relative h-[85vh] flex items-center justify-center text-center px-4 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-orange-900/50 via-orange-800/40 to-orange-50"></div>
        <img 
          src={Shivling}
          alt="Devasthanam Atmosphere" 
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="relative z-10 max-w-4xl">
        <div className="mb-4 inline-block bg-orange-600 text-white px-4 py-1 rounded-full text-xs font-bold uppercase tracking-[0.2em]">
          Swayambhu Marakatha Lingam
        </div>
        <h1 className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 drop-shadow-lg">
          Sri Bramhasutra Marakatha Shivalingam Devasthanam <br/> 
        </h1>
        <p className="text-xl text-orange-50 mb-10 max-w-2xl mx-auto font-medium">
          Experience the divine energy of the 11th-century Emerald Shivalingam, established by King Vikramaditya VI.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <button  onClick={() => window.open('https://www.google.com/maps/place/Chandippa+Marakatha+Shiva+Temple/@17.4450792,78.1093252,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcbef7cfd72586d:0x8727fe5156723643!8m2!3d17.4450792!4d78.1119001!16s%2Fg%2F1hc2gsntv?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D', '_blank')} className="bg-orange-600 hover:bg-orange-500 text-white px-10 py-4 rounded-xl font-bold transition flex items-center gap-2 shadow-xl shadow-orange-900/20">
            <MapPin  size={20} /> View Map
          </button>

        </div>
      </div>
    </section>
  );
};

export default Hero;